import React from "react";
import { Text } from "../Text";
import { CaptionedVideoThumbnail } from "../CaptionedVideoThumbnail";
import { ManagedAccordion } from "../ManagedAccordion";
import { FaqAccordionProps as Props } from "./index";

export const FaqAccordion: React.FC<Props> = ({ question, answer }) => {
  if (!question || !answer) {
    return null;
  }
  const dangerHtml = answer.html ? { __html: answer.html } : null;
  return (
    <div data-testid="FaqAccordion">
      <ManagedAccordion title={question}>
        {answer.text && <Text>{answer.text}</Text>}
        {dangerHtml && <Text dangerouslySetInnerHTML={dangerHtml} />}
        {answer.video && <CaptionedVideoThumbnail {...answer.video} />}
      </ManagedAccordion>
    </div>
  );
};
